module.exports = __webpack_public_path__ + "static/drumroll-b3f22018fbc51e604611ecd5e31639ba.mp3";